export default "__VITE_ASSET__55462b00__"